module.exports = __webpack_public_path__ + "img/just-listed-header.8b7fb359.png";